/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-eval */
import { lotSize } from '../constant';

export const generateBuyFeeData = (
  configFormula,
  lot,
  price,
  isDayTrade = false,
) => {
  const { formula, preview_fee, day_trade } = configFormula;

  const previewFee = isDayTrade ? day_trade?.preview_fee : preview_fee;

  // don't delete these variables! needed for eval below.
  const LOT = lot;
  const PRICE = price;
  const FEE_BUY = isDayTrade ? formula.fee_buy_day_trade : formula.fee_buy;
  const BROKER_FEE = previewFee.broker_fee;
  const EXCHANGE_FEE_TOTAL_BUY = previewFee.exchange.exchange_fee_total_buy;

  const investment = eval(formula.buy_amount_invested); // nosemgrep
  const investmentPlusFee = eval(formula.buy_amount_invested_fee); // nosemgrep
  const brokerFee = eval(formula.buy_amount_broker_fee); // nosemgrep
  const exchangeFee = eval(formula.buy_amount_exchange_fee); // nosemgrep

  return {
    investment,
    investmentPlusFee,
    brokerFee,
    exchangeFee,
  };
};

export const generateSellData = (
  configFormula,
  lot,
  price,
  averagePrice,
  isDayTrade = false,
) => {
  const { formula, preview_fee, day_trade } = configFormula;

  const previewFee = isDayTrade ? day_trade?.preview_fee : preview_fee;

  const LOT = lot;
  const PRICE = price;
  const FEE_BUY = isDayTrade ? formula.fee_buy_day_trade : formula.fee_buy;
  const FEE_SELL = isDayTrade ? formula.fee_sell_day_trade : formula.fee_sell;

  const exchangeFee = previewFee.exchange.compositions.reduce(
    (total, { value }) => total + value,
    0,
  );

  const TOTAL_EXCHANGE_FEE = LOT * PRICE * exchangeFee;

  const SELL_AMOUNT_INVESTED_FEE = eval(formula.sell_amount_invested_fee);
  const BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE = averagePrice * lot * lotSize;
  const BROKER_FEE = previewFee.broker_fee;
  const EXCHANGE_FEE_TOTAL_BUY = previewFee.exchange.exchange_fee_total_buy;
  const EXCHANGE_FEE_TOTAL_SELL = previewFee.exchange.exchange_fee_total_sell;

  const SELL_FEE = eval(formula.ca_sell_amount_fee);
  const SELL_AMOUNT = eval(formula.ca_sell_amount_invested);
  const STOCKBIT_FEE = eval(formula.ca_sell_amount_broker_fee);
  const EXCHANGE_FEE = eval(formula.ca_sell_amount_exchange_fee);
  const CA_SELL_AMOUNT_INVESTED_FEE = eval(formula.ca_sell_amount_invested_fee);
  const SELL_PROFITLOSS = eval(formula.sell_profit_loss);
  const SELL_GAIN = eval(formula.sell_gain) * lotSize;

  return {
    SELL_FEE,
    SELL_AMOUNT,
    STOCKBIT_FEE,
    TOTAL_EXCHANGE_FEE,
    CA_SELL_AMOUNT_INVESTED_FEE,
    SELL_PROFITLOSS,
    SELL_GAIN,
  };
};
